import React from 'react';
import { Box, Typography } from '@mui/material';
import dash1 from '../../../assets/dash1.png';
import dash2 from '../../../assets/dash2.png';
import dash3 from '../../../assets/dash3.png';
import { ReactComponent as ArrowIcon } from '../../../assets/svg/arrow.svg';

interface VideoShowcaseCardProps {
  backgroundImage: string;
  title: string;
  url: string;
}

const VideoShowcaseCard: React.FC<VideoShowcaseCardProps> = ({ backgroundImage, title, url }) => {
  const handleTileClick = () => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  

  return (
    <Box
      className='flex-1 cursor-pointer rounded-xl overflow-hidden relative group'
      onClick={handleTileClick}
      sx={{
        aspectRatio: '16/9',
        transition: 'transform 0.2s ease-in-out',
        '&:hover': {
          transform: 'scale(1.02)',
        },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      />
      
      <Box
        className='absolute bottom-0 left-0 right-0'
        sx={{
          background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
          padding: { xs: '14px', md: '24px' },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          sx={{
            color: '#FFF',
            fontFamily: 'CircularStd',
            fontSize: { xs: '14px', md: '20px' },
            fontStyle: 'normal',
            fontWeight: 900,
            lineHeight: { xs: '18px', md: '24px' },
            textTransform: 'none',
            maxWidth: '75%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
          }}
          component="a"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
          {title}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <ArrowIcon />
        </Box>
      </Box>
    </Box>
  );
};

const VideoShowcase: React.FC = () => {

  return (
    <Box className='mt-[15px] w-full'>
      <Box className='w-full bg-surface rounded-2xl py-[15px] px-[28px] shadow-sm border border-border-token max-md:px-4 max-md:py-3 max-md:rounded-xl'>
        <Typography
          sx={{
            color: 'var(--text)',
            fontFamily: 'CircularStd',
            fontSize: { xs: '15px', md: '18px' },
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: 'normal',
            marginBottom: '16px',
          }}
        >
          Video Case Studies
        </Typography>

        <Box className='flex gap-4 max-md:flex-col max-md:gap-3'>
          <VideoShowcaseCard
            backgroundImage={dash1}
            title="How The Desire Company’s Expert-Led Product Videos Drive Unmatched Conversions for High-Consideration Consumer Electronics"
            url="https://thedesirecompany.com/case-studies/high-consideration-consumer-electronics?ref=tdc-portal"
          />
          <VideoShowcaseCard
            backgroundImage={dash2}
            title="Driving Amazon Prime Day Performance with The Desire Company"
            url="https://thedesirecompany.com/case-studies/driving-amazon-prime-day-performance-with-the-desire-company?ref=tdc-portal"
          />
          <VideoShowcaseCard
            backgroundImage={dash3}
            title="Ergo Impact Experiences the Significant Impact of Desire Co. Videos"
            url="https://thedesirecompany.com/case-studies/ergo-impact-experiences-the-significant-impact-of-desire-co-videos?ref=tdc-portal"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default VideoShowcase;
